// General
import "./drinking-filter-dialog.scss";
import { useEffect, forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateDrinkingFilterDialog } from "../../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide } from "@mui/material";
// Components
import DrinkingFilter from "../../../elements/filters/drinking-filter/drinking-filter";

const DrinkingFilterDialog = () => {
  // Redux variables
  const drinkingFilterDialog = useSelector(
    (state) => state.dialog.drinkingFilterDialog
  );
  const dispatch = useDispatch();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!drinkingFilterDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-DrinkingFilter-Dialog",
      },
    });
  }, [drinkingFilterDialog]);

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateDrinkingFilterDialog(false));
  };

  return (
    <Dialog
      className="custom-bottom-sheet-dialog"
      fullScreen
      open={drinkingFilterDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <DrinkingFilter />
    </Dialog>
  );
};

export default DrinkingFilterDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
